import { PropsWithChildren, useEffect, useState } from 'react'

export const Popup: React.FC<
  PropsWithChildren<{
    open: boolean
    arrowPosition: 'center' | 'right' | 'bottomRight'
  }>
> = ({ children, open, arrowPosition }) => {
  const [heightClass, setHeightClass] = useState(open ? 'h-auto' : 'h-0')
  useEffect(() => {
    if (open) {
      setHeightClass('h-auto')
      return
    }
    const timeoutId = window.setTimeout(() => {
      setHeightClass('h-0')
    }, 200)
    return () => window.clearTimeout(timeoutId)
  }, [open])
  return (
    <div
      className={`${
        open
          ? 'translate-y-0 opacity-100'
          : 'pointer-events-none translate-y-[-10px] opacity-0'
      } relative w-fit rounded-[3px] bg-white shadow-[0_1px_4px_0_rgba(0,0,0,0.3)] duration-200 xl:border xl:border-gray-300 xl:shadow-[0_1px_2px_0_rgba(0,0,0,0.15)] ${
        arrowPosition === 'right'
          ? 'popup-arrow-right xl:popup-arrow-pc-right'
          : arrowPosition === 'bottomRight'
            ? 'popup-arrow-bottom-right xl:popup-arrow-pc-bottom-right'
            : 'popup-arrow-center xl:popup-arrow-pc-center'
      } ${heightClass}`}
      aria-hidden={!open}
      inert={!open}
    >
      {children}
    </div>
  )
}
